import { createApp } from 'vue'
import store from 'store'

import RelatedProductCourse from './RelatedProductCourse.vue'

const el = '.nti-component--related-product-course'
const DOM = document.querySelector(el)

const render = function(){
    if(DOM){
        const app = createApp(RelatedProductCourse)
        app.use(store)
        app.mount(el)
    }
}

export default {
    render
}